<template>
  <div>
    <div class="d-flex flex-column" >
      <div class="row">
        <div class="col-4 d-flex align-items-center text-nowrap px-1 py-2 bg-light pl-1 border-bottom border-right"
          @click="switcher = !switcher" style="cursor: pointer">
          <div class="pr-2 text-truncate">{{item}}</div>
          <font-awesome-icon :id="'accordion-chevron-'+index" :icon="['fas', 'chevron-right']" v-if="!switcher" class="text-secondary small"/>
          <font-awesome-icon :id="'accordion-chevron-'+index" :icon="['fas', 'chevron-down']" v-if="switcher" class="text-secondary small"/>
        </div>
        <div class="col-2 text-nowrap px-1 py-2 text-right border-bottom border-right" v-if="!allwaysAns">{{unit_code_ob[item].correct}}</div>
        <div class="col-2 text-nowrap px-1 py-2 text-right border-bottom border-right">{{unit_code_ob[item].count}}</div>
        <div class="col-2 text-nowrap px-1 py-2 text-right border-bottom border-right" v-if="!allwaysAns">
          {{(100/totalQuestion)*unit_code_ob[item].correct}}</div>
      </div>
      <b-collapse class="" :id="'accordion-'+index" accordion="analyze" v-model="switcher">
        <div class="row text-sevenblack">
          <div class="col-4 border-bottom border-right px-1 py-2"><p class="m-0">1.某科目</p></div>
          <div class="col-2 text-nowrap border-bottom border-right px-1 py-2 text-right"><p class="m-0">aaa</p></div>
          <div class="col-2 text-nowrap border-bottom border-right px-1 py-2 text-right"><p class="m-0">aaa</p></div>
          <div class="col-2 text-nowrap border-bottom border-right px-1 py-2 text-right"><p class="m-0">aaa</p></div>
        </div>
        <div class="row text-sevenblack">
          <div class="col-4 border-bottom border-right px-1 py-2"><p class="m-0">2.某科目</p></div>
          <div class="col-2 text-nowrap border-bottom border-right px-1 py-2 text-right"><p class="m-0">aaa</p></div>
          <div class="col-2 text-nowrap border-bottom border-right px-1 py-2 text-right"><p class="m-0">aaa</p></div>
          <div class="col-2 text-nowrap border-bottom border-right px-1 py-2 text-right"><p class="m-0">aaa</p></div>
        </div>
      </b-collapse>
    </div>
  </div> 
</template>

<script>

export default {
  data() {
    return {
      switcher: false
    }
  },
  props: {
    item: String,
    index: Number,
    unit_code_ob: Object,
    allwaysAns: Boolean,
    totalQuestion: Number,
    visible: Boolean
  }
};

</script>
